import React, { useEffect, useState } from 'react';
import { Avatar, Button, Tag, Form, Card, Typography, Row, Col, Switch, Modal, Input, Drawer } from 'antd';
import { UserOutlined, EditOutlined, MenuOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import 'antd/dist/reset.css';

const { Title, Text } = Typography;
const backend_url = process.env.REACT_APP_BACKEND_URL;

const Profile = () => {
    const [selectedSection, setSelectedSection] = useState('myProfile');
    const [drawerVisible, setDrawerVisible] = useState(false);
    const user = useSelector(data => data.userdetailreducer);
    const location = useLocation(); 

    useEffect(() => {
        if (location.state && location.state.fromNavbar) {
            setSelectedSection('myTrip');
        } else {
            setSelectedSection('myProfile');
        }
    }, [location]);

    const handleSectionChange = (section) => {
        setSelectedSection(section);
        setDrawerVisible(false); // Close the drawer on section change
    };

    const showDrawer = () => {
        setDrawerVisible(true);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
    };

    return (
        <div className="flex flex-col md:flex-row h-screen bg-gray-200">
            {/* Sidebar for large screens */}
            <div className="hidden md:block w-1/4 bg-gray-100 p-4">
                <SidebarContent user={user} onSectionChange={handleSectionChange} />
            </div>

            {/* Drawer for small screens */}
            <Drawer
                title="Menu"
                placement="left"
                onClose={closeDrawer}
                visible={drawerVisible}
                className="md:hidden"
            >
                <SidebarContent user={user} onSectionChange={handleSectionChange} />
            </Drawer>

            {/* Mobile Menu Icon */}
            <Button
                className="block md:hidden m-4"
                icon={<MenuOutlined />}
                onClick={showDrawer}
            />

            {/* Content Area */}
            <div className="w-full md:w-3/4 p-6">
                {selectedSection === 'myProfile' && <MyProfile />}
                {selectedSection === 'myTrip' && <MyTrip />}
                {selectedSection === 'walletCard' && <WalletCard />}
            </div>
        </div>
    );
};

// Sidebar Content Component
const SidebarContent = ({ user, onSectionChange }) => (
    <div className="flex flex-col">
        <div className="text-center mb-8">
            <Avatar size={64} icon={<UserOutlined />} />
            <h2 className="mt-2 text-xl">{user.fname}</h2>
        </div>
        <div className="flex flex-col space-y-4">
            <Button onClick={() => onSectionChange('myProfile')}>My Profile</Button>
            <Button onClick={() => onSectionChange('myTrip')}>My Trip</Button>
            <Button onClick={() => onSectionChange('walletCard')}>Wallet / Card</Button>
        </div>
    </div>
);

// MyProfile Component
const MyProfile = () => {
    const user = useSelector(data => data.userdetailreducer);
    const patch_api_cred = localStorage.getItem('username');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleSubmit = async (values) => {
        values.username = patch_api_cred;
        const payload = values;

        console.log('Form Data:', payload);
        form.resetFields();
        handleCancel();

        const response = await axios.patch(`${backend_url}/api/update-user`, payload, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };

    return (
        <>
            <Card
                className="max-w-4xl mx-auto my-8 p-6 shadow-2xl rounded-lg bg-gradient-to-r from-teal-400 to-blue-500"
                style={{ borderColor: 'transparent' }}
            >
                <Row gutter={[24, 24]} className="flex flex-col md:flex-row items-center">
                    <Col className="flex justify-center md:justify-start md:w-1/3">
                        <Avatar size={120} style={{ backgroundColor: 'gray', color: 'white', fontSize: '2rem' }}>
                            {user.fname ? user.fname[0] : null}
                        </Avatar>
                    </Col>
                    <Col className="md:w-2/3 text-center md:text-left">
                        <Title level={3} className="text-white mb-2">
                            Welcome :- <span className='text-gray-800'>{user.fname}</span>
                        </Title>
                        <Text className="block text-[20px] font-semibold">Username: <span className='text-gray-700 '>{user.username}</span></Text>
                        <Text className="block text-[20px] font-semibold mb-1"> Email: <span className='text-gray-700 '>{user.email}</span></Text>
                        <Text className="block text-[20px] font-semibold">Phone: <span className='text-gray-700 '> {user.mobile}</span></Text>
                    </Col>
                </Row>
                <Button className='absolute bottom-2 right-2' onClick={showModal}>
                    Edit <EditOutlined />
                </Button>
            </Card>

            <Modal
                title="User Information"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleSubmit}>
                    <Form.Item name="fname" label="Full Name">
                        <Input />
                    </Form.Item>
                    <Form.Item name="email" label="Email" rules={[{ type: 'email', message: 'The input is not valid E-mail!' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="mobile" label="Mobile" rules={[
                        { min: 10, message: 'Mobile number must be 10 digits long!' },
                        { max: 10, message: 'Mobile number must be 10 digits long!' },
                        { pattern: /^[0-9]+$/, message: 'Mobile number must be numeric only!' },
                    ]}>
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};









// MyTrip Component remains the same
// WalletCard Component remains the same




const WalletCard = () => {
    return (
        <Card title="Wallet / Card">
        </Card>
    );
};





const MyTrip = () => {
    const user = useSelector((data) => data.userdetailreducer);
    const [ticketdata, setTicketdata] = useState([]);
    const [isToggled, setIsToggled] = useState(true);

    // Fetch user tickets
    const getuser = async () => {
        try {
            const response = await axios.post(`${backend_url}/api/get-booking-ticket`, {
                ticketNumbers: user.ticketNumbers,
            });
            if (response.data && response.data.bookings) {
                setTicketdata(response.data.bookings);
            }
        } catch (error) {
            console.error('Error fetching booking tickets:', error);
        }
    };

    useEffect(() => {
        if (user?.ticketNumbers) {
            getuser();
        }
    }, [user]);

    // Helper function to parse date strings
    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('-');
        return new Date(year, month - 1, day); // months are 0-indexed
    };

    // Get today's date
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight for comparison

    // Separate trips into upcoming and past based on `travelDate`
    const upcomingTrips = ticketdata.filter((trip) => parseDate(trip.travelDate) >= today);
    const pastTrips = ticketdata.filter((trip) => parseDate(trip.travelDate) < today);

    // Toggle state change handler
    const handleToggle = () => {
        setIsToggled(!isToggled);
    };

    return (
        <Card className="h-[80vh] overflow-auto p-4 md:p-6 lg:p-8">
            <div className="flex flex-col">
                {/* Toggle Switch for Pending and Completed Trips */}
                <div className="flex justify-center items-center mt-4 lg:mt-8">
                    <div
                        className="relative w-full max-w-[400px] sm:max-w-[500px] h-[50px] border border-gray-300 rounded-full overflow-hidden cursor-pointer"
                        onClick={handleToggle}
                    >
                        <div className="absolute inset-0 flex justify-around items-center">
                            <span className="text-gray-700 font-medium">{`Pending - ${upcomingTrips.length}`}</span>
                            <span className="text-gray-700 font-medium">{`Completed - ${pastTrips.length}`}</span>
                        </div>

                        <div
                            className={`absolute top-0 left-0 w-[50%] h-full transition-transform duration-300 ease-in-out ${isToggled ? 'translate-x-0' : 'translate-x-full'}`}
                            style={{
                                backgroundColor: isToggled ? '#4CAF50' : '#FF5722',
                            }}
                        >
                            <div className="flex justify-center items-center h-full text-white">
                                {isToggled ? `Pending - ${upcomingTrips.length}` : `Completed - ${pastTrips.length}`}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Upcoming or Past Trips */}
                <div className="mt-8">
                    {isToggled ? (
                        <div>
                            <h3 className="text-center text-lg font-semibold mb-4">Upcoming Trips</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 justify-items-center">
                                {upcomingTrips.map((trip) => (
                                    <Card
                                        key={trip._id}
                                        className="w-full sm:max-w-[350px] lg:w-[500px] rounded-lg shadow-lg bg-gradient-to-tr from-blue-500 via-blue-300 to-blue-500 text-white"
                                        cover={
                                            <div className="p-4 text-center text-black font-bold bg-opacity-50">
                                                {trip.fromCity || 'N/A'} to {trip.toCity || 'N/A'}
                                            </div>
                                        }
                                    >
                                        <div className="p-4">
                                            <p className="text-gray-800">
                                                <strong>Bus Name:</strong> {trip.busName}
                                            </p>
                                            <p className="text-gray-800">
                                                <strong>From Date:</strong> {trip.travelDate}
                                            </p>
                                            <p className="text-gray-800">
                                                <strong>Status:</strong>{' '}
                                                <Tag color={trip.status === 'booked' ? 'green' : 'red'}>
                                                    {trip.status}
                                                </Tag>
                                            </p>
                                            <p className="text-gray-800">
                                                <strong>Seat Number:</strong> {trip.seatNumber}
                                            </p>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <h3 className="text-center text-lg font-semibold mb-4">Past Trips</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 justify-items-center">
                                {pastTrips.map((trip) => (
                                    <Card
                                        key={trip._id}
                                        className="w-full sm:max-w-[350px] lg:w-[500px] rounded-lg shadow-lg bg-gradient-to-tr from-gray-600 via-gray-500 to-gray-900 text-white"
                                        cover={
                                            <div className="p-4 text-center text-black font-bold bg-opacity-50">
                                                {trip.fromCity || 'N/A'} to {trip.toCity || 'N/A'}
                                            </div>
                                        }
                                    >
                                        <div className="p-4">
                                            <p>
                                                <strong>Bus Name:</strong> {trip.busName}
                                            </p>
                                            <p>
                                                <strong>From Date:</strong> {trip.travelDate}
                                            </p>
                                            <p>
                                                <strong>Status:</strong>{' '}
                                                <Tag color={trip.status === 'booked' ? 'green' : 'red'}>
                                                    {trip.status}
                                                </Tag>
                                            </p>
                                            <p>
                                                <strong>Seat Number:</strong> {trip.seatNumber}
                                            </p>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

// export default MyTrip;





export default Profile;
